export default __webpack_public_path__ + "static/media/plastiboo.4b1c3921.jpeg";